import groupSetApi from '../../../services/plataforma/groupset';

export default {
  getAll(_, { limit, offset, filter, sortBy, order, mainId, isActive, getGroups, paginated = true }) {
    return groupSetApi.getAll({ limit, offset, filter, sortBy, order, mainId, isActive, getGroups, paginated })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  create(_, payload) {
    return groupSetApi.create(payload)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  edit(_, payload) {
    return groupSetApi.edit(payload)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  getById(_, { id }) {
    return groupSetApi.getById(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  delete(_, { id }) {
    return groupSetApi.delete(id)
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  },
  getGroupsOfSet(_, { id }) {
    return groupSetApi.getGroupsOfSet(id)
      .then(response => Promise.resolve(response.data.groups))
      .catch(e => Promise.reject(e.response.data.error));
  },
  getAvailableParticipants(_, { mainId, groupSetId, searchName, page, perPage }) {
    return groupSetApi.getAvailableParticipants({ mainId, groupSetId, searchName, page, perPage })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  createGroup(_, { name, isActive, groupSetId }) {
    return groupSetApi.createGroup({
      name,
      isActive,
      groupSetId
    })
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  },
  editGroup(_, { id, name, isActive, groupSetId }) {
    return groupSetApi.editGroup({
      id,
      name,
      isActive,
      groupSetId
    })
      .then(() => Promise.resolve())
      .catch(e => Promise.reject(e.response.data.error));
  },
  getAllByContentId(_, contentId) {
    return groupSetApi.getAllByContentId(contentId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  getParticipants(_, { academicMainId, groupSetId, page, itemsPerPage, search, hasGroup, mainGroupId, sortDirection, orderBy }) {
    return groupSetApi.getParticipants({ academicMainId, groupSetId, page, itemsPerPage, search, hasGroup, mainGroupId, sortDirection, orderBy })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  getGroupsByParticipantsCount(_, { academicMainId, groupSetId, countParticipants }) {
    return groupSetApi.getGroupsByParticipantsCount({ academicMainId, groupSetId, countParticipants })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionMoveParticipantsBetweenGroups(_, { groupId, groupChangeConfiguration, enrollmentIds, groupSetId, courseId }) {
    return groupSetApi.moveParticipantsBetweenGroups({ groupId, groupChangeConfiguration, enrollmentIds, groupSetId, courseId })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  actionGetAllParticipantsByMainGroupId(_, { groupsetId, courseId, hasGroup, search, mainGroupId, sortBy, sortDirection }) {
    return groupSetApi.getAllParticipantsByMainGroupId({ groupsetId, courseId, hasGroup, search, mainGroupId, sortBy, sortDirection })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  }
};
